import { css } from 'styled-components';
import { theme } from './utilities';

export const WithInheritFontCss = css`
  font-family: inherit;
  font-kerning: inherit;
  font-size-adjust: inherit;
  font-size: inherit;
  font-stretch: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: inherit;
`;

export const WithSpanCss = css`
  font-size: 0.75rem;
  color: ${(props) => props.color || theme.colors.common.span};
  letter-spacing: 0.2px;
  line-height: 1rem;
  ${({ small }) => small && WithSpanSmallCss}
  ${({ smallest }) => smallest && WithSpanSmallestCss}
  ${({ displayBlock }) => displayBlock && 'display: block; margin-bottom: .5rem;'}
`;

const WithSpanSmallCss = css`
  font-size: 0.625rem;
  letter-spacing: 0.5px;
  font-weight: bold;
  text-transform: uppercase;
`;

const WithSpanSmallestCss = css`
  font-size: 0.625rem;
  letter-spacing: 0.2px;
`;

export const WithWordWrapCss = css`
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
`;
